import { useEffect } from 'react';
import { Modal, Form, Input } from 'antd';
import { InputModal } from '../common/InputModal';
import "./EditIndustryTypeFormFields";
import { EditIndustryTypeFormData } from './EditIndustryTypeFormFields';
const EditIndustryTypeModal = ({ propsData }) => {
  const { open, setOpen, data, actions } = propsData;
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.setFieldsValue({ name: data });
    }
  }, [open, data, form]);

  const handleUpdate = () => {
    form.validateFields()
      .then(() => {
        const updatedData = form.getFieldsValue();
        actions.handleIndustryTypeEdit(updatedData);
        setOpen(false);
      })
      .catch((errorInfo) => {
        console.log('Validation failed:', errorInfo);
      });
  };

  const handleCancel = () => {
    form.resetFields();
    setOpen(false);
  };

  return (
    <InputModal
      propsData={{
        title: "Edit Industry Type",
        data: data,
        placeholder:'',
        open: open,
        onCancel: handleCancel,
        onOk: handleUpdate,
        okText: "Update",
        formItems: EditIndustryTypeFormData,
        form: form 
      }}
    />
  );
};

export default EditIndustryTypeModal;
